<script>
    import GameTile from './GameTile.svelte';
    export let tileRow;
</script>

<div>
    {#each tileRow as tileActive}
        <GameTile isActiveTile={tileActive}/>
    {/each}
</div>

<style>
    div {
        display: flex;
        width:100%;
        height:80%;
        margin: 0px;
    }
</style>